import PropTypes from "prop-types";
import React, {forwardRef, Fragment, useEffect, useState} from "react";
import MetaTags from "react-meta-tags";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import ReactGA from "react-ga4";
import {useTranslation} from "react-i18next";
import axios from "axios";
import parse from "react-html-parser";
import moment from "moment";
import {Col, Row, Spinner} from "react-bootstrap";
import {
    BsCalendarMonth,
    BsClock,
    BsPinMap,
    BsStar,
    BsStarFill,
    CgWebsite,
    FaMountain, FaRunning,
    IoMdPricetags
} from "react-icons/all";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {styled} from "@mui/material/styles";
import {ButtonBase} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import {BrowserView, isMobileOnly, isTablet} from 'react-device-detect';
import RelatedProductSlider from "../../wrappers/product/RelatedProductSlider";
import RelatedProductRaceSlider from "../../wrappers/product/RelatedProductRaceSlider";

const StyledTab = styled(Tab)({
    '&.MuiTab-root.Mui-selected': {
        color: 'white',
        backgroundColor: "gray",
        borderRadius: "30px 30px 0 0",
        marginLeft: "10px",
        paddingTop: "0"
    },
    '&.MuiTab-root': {
        color: 'white',
        backgroundColor: "darkgray",
        borderRadius: "30px 30px 0 0",
        marginLeft: "10px",
        paddingTop: "0"
    },
    "&.MuiTabs-scrollButtons.Mui-disabled": {
        paddingBottom: "15px",
        opacity: "0.3"
    },
    '&.MuiTab-root.MuiTabs-indicator': {
        display: "none !important"
    }
})

const Race = ({location}) => {
    const {pathname} = location;
    let slug = location.pathname.split("/race/").pop()
    const [date, setDate] = useState('')
    const [race, setRace] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tabValue, setTabValue] = useState(0);
    const [isSmallScreen, setSmallScreen] = useState(false);
    const [events, setEvents] = useState([])

    useEffect(() => {
        if (race && race.events && race.events.length > 0){
            var events = []
            race.events.map((event) => {
                let distance
                if (event.distance == ""){
                    distance = event.label
                } else {
                    distance = event.distance
                }
                if(race.type == "athletisme"){
                    events.push(event.label)
                } else {
                    if(distance != ""){
                        if(distance == "J10_13" || distance == "J8_11" || distance == "J6_9" || distance == "J12_19"){
                            distance = "Jeunes"
                        }
                        events.push(distance)
                    }
                }
            })
            let uniqueChars = [...new Set(events)];
            setEvents(uniqueChars)
        }
        }, [race])

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        } else {
            setSmallScreen(false)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        } else {
            setSmallScreen(true)
        }
    })

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const splitDistanceMobile = (distance, label) => {
        distance = distance.replaceAll(" - Salle", "")
        distance = distance.replaceAll(" - salle", "")

        let d = distance.split(" - ")
        let newArray = []
        d.map(el => {
            const distance = el.substring(0, el.indexOf("("));
            if (distance != ""){
                var mySubString = el.substring(
                    el.indexOf("(") + 1,
                    el.lastIndexOf(")")
                );
                mySubString = Array.from(new Set(mySubString.split(', '))).toString();
                if (label != "Lancers" && label != "Sprint - haies)"){
                    newArray.push(distance + " ("+mySubString+ ")")
                } else {
                    newArray.push(el)
                }
            } else {
                newArray.push(el)
            }
        })
        return newArray
    }

    useEffect(() => {
        ReactGA.send({hitType: "pageview", page: location.pathname});
        fetchData(slug)
    }, [slug])

    Array.prototype.contains = function (element) {
        return this.indexOf(element) > -1;
    };

    useEffect(() => {
        if (race && race.beginDate != race.endDate) {
            moment.locale("fr");
            var beginDay = new Date(race.beginDate).getDate()
            var beginDateFormat = moment(race.beginDate);
            var beginMonthStr = beginDateFormat.locale("fr").format('MMM')
            var beginYearStr = beginDateFormat.year()

            var endDay = new Date(race.endDate).getDate()
            var endDateFormat = moment(race.endDate);
            var endMonthStr = endDateFormat.locale("fr").format('MMM')
            var endYearStr = endDateFormat.year()

            if (endYearStr == beginYearStr) {
                if (beginMonthStr != endMonthStr) {
                    setDate(beginDay + " " + beginMonthStr + " au " + endDay + " " + endMonthStr + " " + endDateFormat.year())
                } else {
                    setDate(beginDay + " au " + endDay + " " + endMonthStr + " " + endDateFormat.year())
                }
            } else {
                if (beginMonthStr != endMonthStr) {
                    setDate(beginDay + " " + beginMonthStr + " " + beginYearStr + " au " + endDay + " " + endMonthStr + " " + endDateFormat.year())
                } else {
                    setDate(beginDay + " au " + endDay + " " + endMonthStr + " " + endDateFormat.year())
                }
            }

        } else if (race) {
            var beginDay = new Date(race.beginDate).getDate()
            var endDateFormat = moment(race.endDate);
            var endMonthStr = endDateFormat.locale("fr").format('MMM')
            setDate(beginDay + " " + endMonthStr + " " + endDateFormat.year())
        }
    }, [race])

    const fetchData = (slug) => {
        let query = 'https://public-front-api.therunningcollective.fr/race?shortURL=' + slug
        axios
            .get(query)
            .then((res) => {
                let race = res.data
                setRace(res.data)
                setLoading(false);
                window.prerenderReady = true
            })
            .catch((err) => {
                //window.location.href = "/404-not-found"
                console.log(err);
            })

    };

    const {t} = useTranslation();

    return (
        <Fragment>
            <MetaTags>
                <title>{race && race.name ? race.name + " - Toutes les infos !" : "The Running Collective"}</title>
                <meta
                    name="description"
                    content={race && race.name ? race.name + " : retrouve ici toutes les informations pratiques pour la course !" :
                        "Retrouves ici toutes les informations essentielles pour la course !"}
                />
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type"
                      content={race && race.name + " - Toutes les infos !" ? race.name : "The Running Collective"}/>
                <meta property="og:description"
                      content={race && race.name ? race.name + " : retrouve ici toutes les informations pratiques pour la course !" :
                          "Retrouves ici toutes les informations essentielles pour la course !"}
                />
                <meta property="og:image" content={
                    race && race.image && race.image != "" ? race.image :
                        race && race.image && race.type == "trail" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/trail-running.jpeg" :
                            race && race.image && race.type == "triathlon" ? "https://img.therunningcollective.fr/triathlonjeunes-5-jpeg" :
                                race && race.image && race.type == "athletisme" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/sportcentrum-in-Oordegem-luchtfoto-Persregio-Dender.jpeg"
                                    : "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"}/>
            </MetaTags>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>{t('home')}</BreadcrumbsItem>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + "/races?page=1&startDate=" +
                moment().locale('fr').format('L') + "&endDate=" +
               moment().add(1, 'M').locale('fr').format('L')}>Toutes les courses</BreadcrumbsItem>

            {
                race && race.country != "" ?
                    <BreadcrumbsItem
                        to={process.env.PUBLIC_URL + "/races?destination=" + race.country + "&page=1&startDate=" +
                            moment().locale('fr').format('L') + "&endDate=" +
                           moment().add(1, 'M').locale('fr').format('L')}>
                        {race.country}
                    </BreadcrumbsItem>
                    : null
            }
            {
                race && race.region != "" ?
                    <BreadcrumbsItem
                        to={process.env.PUBLIC_URL + "/races?destination=" + race.region + "&page=1&startDate=" +
                            moment().locale('fr').format('L') + "&endDate=" +
                           moment().add(1, 'M').locale('fr').format('L')}>
                        {race.region}
                    </BreadcrumbsItem>
                    : null
            }
            {
                race && race.department != "" && race.region != race.department && race.town != race.department ?
                    <BreadcrumbsItem
                        to={process.env.PUBLIC_URL + "/races?destination=" + race.department + "&page=1&startDate=" +
                            moment().locale('fr').format('L') + "&endDate=" +
                           moment().add(1, 'M').locale('fr').format('L')}>
                        {race.department}
                    </BreadcrumbsItem>
                    : null
            }
            {
                race && race.town != "" && race.region != race.town && race.department != race.town ?
                    <BreadcrumbsItem
                        to={process.env.PUBLIC_URL + "/races?destination=" + race.town + "&page=1&startDate=" +
                            moment().locale('fr').format('L') + "&endDate=" +
                           moment().add(1, 'M').locale('fr').format('L')}>
                        {race.town}
                    </BreadcrumbsItem>
                    : null
            }

            <LayoutOne headerTop="visible"
                       headerContainerClass="container-fluid"
                       headerPaddingClass="header-padding-2"
                       location={location}>
                {/* breadcrumb */}
                <Breadcrumb/>

                <BrowserView>
                    {!isTablet ?
                        <div className="container-fluid" style={{
                            textAlign: "center",
                            paddingBottom: "10px",
                            paddingTop: "10px"
                        }}>
                            <p style={{fontSize: "18px", fontWeight: 500}}>FICHE DE COURSE</p>
                        </div> : null}
                </BrowserView>

                <BrowserView>
                    {!isTablet ?
                        !loading && race ?
                            <div>
                                <div className="container" style={{textAlign: "center", marginBottom: "20px"}}>
                                    <div style={{position: "relative", height: "200px"}}>
                                        <div style={{zIndex: "1", height: "100%"}}>
                                            {
                                                race && race.name ?
                                                    <div style={{
                                                        left: 0,
                                                        position: "absolute",
                                                        textAlign: "center",
                                                        top: "40%",
                                                        width: "100%",
                                                        color: "white", zIndex: "2", fontSize: "200%"
                                                    }}>
                                                        <h1 style={{
                                                            fontSize: "30px",
                                                            color: "white",
                                                            fontWeight: 700,
                                                            margin:"0"
                                                        }}>{race.name.toUpperCase()}</h1>
                                                    </div> : null
                                            }
                                            <img
                                                style={{
                                                    position: "relative",
                                                    width: "100%",
                                                    borderRadius: "5px",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    overflow: "hidden",
                                                    filter: "brightness(0.6)"
                                                }}
                                                onError={({currentTarget}) => {
                                                    currentTarget.onerror = null; // prevents looping
                                                    currentTarget.src = "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"
                                                }}
                                                src={
                                                    race && race.image && race.image != "" ? race.image :
                                                        race && race.image && race.type == "trail" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/trail-running.jpeg" :
                                                            race && race.image && race.type == "triathlon" ? "https://img.therunningcollective.fr/triathlonjeunes-5-jpeg" :
                                                                race && race.image && race.type == "athletisme" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/sportcentrum-in-Oordegem-luchtfoto-Persregio-Dender.jpeg"
                                                                    : "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="container">
                                    <Row>
                                        <Col xs={5}>
                                            <Row>
                                                <Col xs={3} style={{
                                                    color: 'white',
                                                    backgroundColor: 'grey',
                                                    marginLeft: "15px",
                                                    textAlign: "center",
                                                    padding: "0 10px 5px 10px",
                                                    borderRadius: "0 0 50% 50%",
                                                    textTransform: "uppercase"
                                                }}>
                                                    {race.type ? race.type.toUpperCase() : null}
                                                </Col>
                                                {
                                                    race && (race.name.toLowerCase().includes("10km") ||
                                                        race.description.toLowerCase().includes("10km") ||
                                                        race.name.toLowerCase().includes("10 km") ||
                                                        race.description.toLowerCase().includes("10 km")) ?
                                                        <Col xs={3} style={{
                                                            color: 'white',
                                                            backgroundColor: 'green',
                                                            marginLeft: "15px",
                                                            textAlign: "center",
                                                            padding: "0 10px 5px 10px",
                                                            borderRadius: "0 0 50% 50%",
                                                            textTransform: "uppercase"
                                                        }}>
                                                            10KM
                                                        </Col> : race && (race.name.toLowerCase().includes("marathon") || race.description.toLowerCase().includes("marathon")) ?
                                                            <Col xs={3} style={{
                                                                color: 'white',
                                                                backgroundColor: 'green',
                                                                marginLeft: "15px",
                                                                textAlign: "center",
                                                                padding: "0 10px 5px 10px",
                                                                borderRadius: "0 0 50% 50%",
                                                                textTransform: "uppercase"
                                                            }}>
                                                                Marathon
                                                            </Col>
                                                            : race && (race.name.toLowerCase().includes("semi") || race.description.toLowerCase().includes("semi")) ?
                                                                <Col xs={3} style={{
                                                                    color: 'white',
                                                                    backgroundColor: 'green',
                                                                    marginLeft: "15px",
                                                                    textAlign: "center",
                                                                    padding: "0 10px 5px 10px",
                                                                    borderRadius: "0 0 50% 50%",
                                                                    textTransform: "uppercase"
                                                                }}>
                                                                    Semi-Marathon
                                                                </Col> : race && (race.name.toLowerCase().includes("100km") || race.description.toLowerCase().includes("100km" ||
                                                                    race.name.includes("100 km") || race.description.includes("100 km"))) ?
                                                                    <Col xs={3} style={{
                                                                        color: 'white',
                                                                        backgroundColor: 'green',
                                                                        marginLeft: "15px",
                                                                        textAlign: "center",
                                                                        padding: "0 10px 5px 10px",
                                                                        borderRadius: "0 0 50% 50%",
                                                                        textTransform: "uppercase"
                                                                    }}>
                                                                        100KM
                                                                    </Col> : race && (race.name.toLowerCase().includes("ironman") || race.description.toLowerCase().includes("ironman")) ?
                                                                        <Col xs={3} style={{
                                                                            color: 'white',
                                                                            backgroundColor: 'green',
                                                                            marginLeft: "15px",
                                                                            textAlign: "center",
                                                                            padding: "0 10px 5px 10px",
                                                                            borderRadius: "0 0 50% 50%",
                                                                            textTransform: "uppercase"
                                                                        }}>
                                                                            IRONMAN®
                                                                        </Col> : race && (race.name.toLowerCase().includes("utmb") || race.description.toLowerCase().includes("utmb")) ?
                                                                            <Col xs={3} style={{
                                                                                color: 'white',
                                                                                backgroundColor: 'green',
                                                                                marginLeft: "15px",
                                                                                textAlign: "center",
                                                                                padding: "0 10px 5px 10px",
                                                                                borderRadius: "0 0 50% 50%",
                                                                                textTransform: "uppercase"
                                                                            }}>
                                                                                UTMB®
                                                                            </Col> : race.tags && race.tags.length > 1 ?
                                                                                <Col xs={3} style={{
                                                                                    color: 'white',
                                                                                    backgroundColor: 'green',
                                                                                    marginLeft: "15px",
                                                                                    textAlign: "center",
                                                                                    padding: "0 10px 5px 10px",
                                                                                    borderRadius: "0 0 50% 50%",
                                                                                    textTransform: "uppercase"
                                                                                }}>
                                                                                    {race.tags[1]}
                                                                                </Col> : null
                                                }

                                                {
                                                    race.tags && race.tags.length > 0 && race.tags.contains("mountain") ?
                                                        <Col xs={3} style={{
                                                            color: 'white',
                                                            backgroundColor: 'orange',
                                                            marginLeft: "15px",
                                                            textAlign: "center",
                                                            padding: "0 10px 5px 10px",
                                                            borderRadius: "0 0 50% 50%",
                                                            textTransform: "uppercase"
                                                        }}>
                                                            Montagne
                                                        </Col> : race.tags && race.tags.length > 0 && race.tags.contains("off-road") ?
                                                            <Col xs={3} style={{
                                                                color: 'white',
                                                                backgroundColor: 'orange',
                                                                marginLeft: "15px",
                                                                textAlign: "center",
                                                                padding: "0 10px 5px 10px",
                                                                borderRadius: "0 0 50% 50%",
                                                                textTransform: "uppercase"
                                                            }}>
                                                                Sentier
                                                            </Col> : race.tags && race.tags.length > 0 && race.tags.contains("city") ?
                                                                <Col xs={3} style={{
                                                                    color: 'white',
                                                                    backgroundColor: 'orange',
                                                                    marginLeft: "15px",
                                                                    textAlign: "center",
                                                                    padding: "0 10px 5px 10px",
                                                                    borderRadius: "0 0 50% 50%",
                                                                    textTransform: "uppercase"
                                                                }}>
                                                                    En Ville
                                                                </Col> : null
                                                }

                                            </Row>
                                            <div style={{paddingTop: "20px"}}>
                                                <Row>
                                                    <Col xs={1}>
                                                        <BsPinMap size={"2em"}/>
                                                    </Col>
                                                    <Col xs={10} style={{
                                                        marginLeft: "10px",
                                                        fontSize: "15px",
                                                        fontWeigh: "500"
                                                    }}>
                                                        {race.town} {race.country ? "(" + race.country + ")" : null}
                                                    </Col>
                                                </Row>
                                                <Row style={{paddingTop: "10px"}}>
                                                    <Col xs={1}>
                                                        <BsCalendarMonth size={"2em"}/>
                                                    </Col>
                                                    <Col xs={10} style={{
                                                        marginLeft: "10px",
                                                        fontSize: "15px",
                                                        fontWeigh: "500"
                                                    }}>
                                                        {date}
                                                    </Col>
                                                </Row>
                                                {
                                                    race.beginningHour != "" ?
                                                        <Row style={{paddingTop: "10px"}}>
                                                            <Col xs={1}>
                                                                <BsClock size={"2em"}/>
                                                            </Col>
                                                            <Col xs={10} style={{
                                                                marginLeft: "10px",
                                                                fontSize: "15px",
                                                                fontWeigh: "500"
                                                            }}>
                                                                A partir de {race.beginningHour}
                                                            </Col>
                                                        </Row>
                                                        : null
                                                }
                                                <div style={{paddingTop: "10px"}}>
                                                    {race.starRate == "1" ?
                                                        <div>
                                                            <BsStarFill size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;
                                                            <BsStar size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;
                                                            <BsStar size={"2em"}/>
                                                        </div> : race.starRate == "2" ?
                                                            <div>
                                                                <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                                size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;<BsStar
                                                                size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                                            </div>
                                                            : race.starRate == "3" ?
                                                                <div>
                                                                    <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                                    size={"2em"}/>&nbsp;<BsStarFill size={"2em"}/>&nbsp;
                                                                    <BsStar size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                                                </div> : race.starRate == "4" ?
                                                                    <div>
                                                                        <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                                        size={"2em"}/>&nbsp;<BsStarFill
                                                                        size={"2em"}/>&nbsp;<BsStarFill
                                                                        size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                                                    </div> : race.starRate == "5" ?
                                                                        <div>
                                                                            <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                                            size={"2em"}/>&nbsp;<BsStarFill
                                                                            size={"2em"}/>&nbsp;<BsStarFill
                                                                            size={"2em"}/>&nbsp;<BsStarFill
                                                                            size={"2em"}/>
                                                                        </div> : null
                                                    }
                                                </div>
                                                {race.lowPrice && race.lowPrice != "0"  && race.lowPrice != "0€" ?
                                                    <Row style={{paddingTop: "10px"}}>
                                                        <Col xs={1}>
                                                            <IoMdPricetags size={"2em"}/>
                                                        </Col>
                                                        <Col xs={10} style={{
                                                            marginLeft: "10px",
                                                            fontSize: "15px",
                                                            fontWeigh: "500"
                                                        }}>
                                                            A partir
                                                            de {race.lowPrice.includes("€") ? race.lowPrice : race.lowPrice + "€"}
                                                        </Col>
                                                    </Row>
                                                    :
                                                    <Row style={{paddingTop: "10px"}}>
                                                        <Col xs={1}>
                                                            <IoMdPricetags size={"2em"}/>
                                                        </Col>
                                                        <Col xs={10} style={{
                                                            marginLeft: "10px",
                                                            fontSize: "15px",
                                                            fontWeigh: "500"
                                                        }}>
                                                            Prix non communiqué
                                                        </Col>
                                                    </Row>}
                                                {race.raceLink != "" ?
                                                    <Row style={{paddingTop: "10px"}}>
                                                        <Col xs={1}>
                                                            <CgWebsite size={"2em"}/>
                                                        </Col>
                                                        <Col xs={10} style={{
                                                            marginLeft: "10px",
                                                            fontSize: "15px",
                                                            fontWeigh: "500"
                                                        }}>
                                                            <a href={race.raceLink} target="_blank"
                                                               style={{fontSize: "15px", fontWeigh: "500"}}>Voir le site
                                                                de la course</a>
                                                        </Col>
                                                    </Row>
                                                    : null
                                                }
                                            </div>
                                        </Col>
                                        <Col xs={7}>
                                            <div>
                                                {race && race.description && race.description != "" ?
                                                    <div style={{
                                                        border: "1px solid black",
                                                        borderRadius: "5px",
                                                        padding: "10px",
                                                        marginBottom: "20px"
                                                    }}>
                                                        <b>L'ÉVÈNEMENT EN QUELQUES MOTS :</b>
                                                        <div className="race-mobile-description">
                                                            {parse(race.description)}
                                                        </div>
                                                    </div> : <div style={{
                                                        border: "1px solid black",
                                                        borderRadius: "5px",
                                                        padding: "10px",
                                                        marginBottom: "20px"
                                                    }}>
                                                        <b>L'ÉVÈNEMENT EN QUELQUES MOTS :</b>
                                                        <div>
                                                            {race.type == "running" ?
                                                                <h2 style={{fontSize:"14px", lineHeight:"22px"}}>
                                                                    Préparez-vous à vivre l'excitation pure de la
                                                                    compétition sur route ! Notre course vous offre une
                                                                    expérience inoubliable, alliant vitesse, endurance
                                                                    et détermination. Parcourez les rues animées de la
                                                                    ville, vibrez au rythme de l'énergie collective des
                                                                    coureurs et de la foule en liesse.
                                                                    Que vous soyez un athlète aguerri ou un amateur
                                                                    passionné, cette course est conçue pour tous les
                                                                    niveaux. En franchissant la ligne de départ, vous
                                                                    vous lancerez dans un voyage où chaque foulée vous
                                                                    rapproche de l'accomplissement personnel. Ressentez
                                                                    l'adrénaline monter en vous tandis que vous dépassez
                                                                    vos limites, repoussez vos propres records et
                                                                    inspirez les autres avec votre détermination. Soyez
                                                                    prêt à ressentir l'euphorie de franchir la ligne
                                                                    d'arrivée, porté par les acclamations et la fierté
                                                                    d'avoir relevé le défi. Êtes-vous prêt à vivre une
                                                                    expérience de course sur route inoubliable ?
                                                                </h2> : race.type == "trail" ?

                                                                    <h2  style={{fontSize:"14px", lineHeight:"22px"}}>Êtes-vous prêt à relever le défi ultime de la
                                                                        nature sauvage ? Notre trail vous invite à
                                                                        explorer les sentiers les plus exigeants et
                                                                        pittoresques de la région.

                                                                        Plongez au cœur d'une aventure épique, où chaque
                                                                        pas vous rapproche de la beauté naturelle et de
                                                                        l'adrénaline pure. Traversez des paysages à
                                                                        couper le souffle, entre montagnes majestueuses,
                                                                        forêts verdoyantes et rivières tumultueuses.

                                                                        Êtes-vous prêt à repousser vos limites
                                                                        ?</h2> : race.type == "triathlon" ?

                                                                        <h2  style={{fontSize:"14px", lineHeight:"22px"}}>
                                                                            Préparez-vous à plonger dans une aventure
                                                                            sportive complète
                                                                            avec {race.name.toUpperCase()} !<br/><br/>

                                                                            Ce défi ultime combine natation, cyclisme et
                                                                            course à pied pour tester vos compétences
                                                                            athlétiques et votre endurance.<br/>
                                                                            Plongez dans les eaux claires et
                                                                            cristallines, faites des vagues en vous
                                                                            déplaçant avec grâce et puissance dans la
                                                                            première étape de la natation.<br/>
                                                                            Ensuite, enfourchez votre vélo et parcourez
                                                                            des paysages pittoresques et variés, en
                                                                            pédalant avec détermination et en repoussant
                                                                            vos limites.<br/><br/>

                                                                            Enfin, chaussez vos chaussures de course et
                                                                            dévalez les routes et sentiers, en puisant
                                                                            dans vos réserves d'énergie pour franchir la
                                                                            ligne d'arrivée avec panache.<br/>
                                                                            Notre triathlon offre une expérience
                                                                            incroyable, où vous vous mesurerez à
                                                                            vous-même et aux autres athlètes, dans une
                                                                            compétition amicale et stimulante.<br/><br/>

                                                                            Vous serez inspiré par l'esprit de
                                                                            camaraderie et la détermination des
                                                                            participants qui repoussent leurs propres
                                                                            limites pour atteindre
                                                                            l'excellence.<br/><br/>
                                                                            Êtes-vous prêt à plonger dans ce défi
                                                                            triathlonien et à devenir un véritable
                                                                            champion ?<br/>
                                                                        </h2> : null

                                                            }
                                                        </div>
                                                    </div>}
                                                {
                                                    race.registrationLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) > new Date().setHours(0,0,0,0))?
                                                        <a href={race.registrationLink} target="_blank">
                                                            <div style={{
                                                                border: "3px solid black",
                                                                backgroundColor: "#4fa0a6",
                                                                borderRadius: "5px",
                                                                height: "45px",
                                                                textAlign: "center",
                                                                color: "white",
                                                                top: "15px",
                                                                marginBottom: "20px"
                                                            }}>
                                                                <p style={{
                                                                    paddingTop: "10px",
                                                                    fontWeight: "500",
                                                                    fontSize: "18px",
                                                                    color: "white",
                                                                }}>LIEN DE L'INSCRIPTION</p></div>
                                                        </a>

                                                        : null
                                                }
                                                {
                                                    race.liveLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))?
                                                        <a href={race.liveLink} target="_blank">
                                                            <div style={{
                                                                border: "1px solid black",
                                                                backgroundColor: "orange",
                                                                borderRadius: "5px",
                                                                height: "45px",
                                                                textAlign: "center",
                                                                color: "white",
                                                                top: "15px",
                                                                marginBottom: "20px"
                                                            }}>
                                                                <p style={{
                                                                    paddingTop: "10px",
                                                                    fontWeight: "500",
                                                                    fontSize: "18px",
                                                                    textTransform:"uppercase"
                                                                }}>Lien des résultats</p></div>
                                                        </a>

                                                        : null
                                                }
                                                {
                                                    race.racePicturesLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))?
                                                        <a href={race.racePicturesLink} target="_blank">
                                                            <div style={{
                                                                border: "1px solid black",
                                                                backgroundColor: "red",
                                                                borderRadius: "5px",
                                                                height: "45px",
                                                                textAlign: "center",
                                                                color: "white",
                                                                top: "15px",
                                                                marginBottom: "20px"
                                                            }}>
                                                                <p style={{
                                                                    paddingTop: "10px",
                                                                    fontWeight: "500",
                                                                    fontSize: "18px",
                                                                    textTransform:"uppercase",
                                                                    color: "white"
                                                                }}>Lien des photos</p></div>
                                                        </a>

                                                        : null
                                                }
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row style={{paddingBottom: "30px"}}>
                                        <Col xs={7}>
                                            <Box sx={{width: '100%'}}>
                                                <Box sx={{
                                                    borderBottom: 1,
                                                    borderColor: 'divider',
                                                    maxHeight: "30px",
                                                    overflowY: "hidden",
                                                    marginLeft: race.events && race.events.length < 6 ? "15px" : "0"
                                                }}>
                                                    <Tabs
                                                        TabIndicatorProps={{sx: {display: "none"}}}
                                                        value={tabValue} onChange={handleTabChange}
                                                        aria-label="basic tabs example"
                                                        ScrollButtonComponent={MyTabScrollButton}
                                                        variant={race.events && race.events.length > 6 ? "scrollable" : "none"}
                                                        scrollButtons={race.events && race.events.length > 6 ? "auto" : "none"}
                                                    >
                                                        {
                                                            race.events && race.events.length > 0 ?
                                                                race.events.sort((a, b) => a.label.localeCompare(b.label)).map(ev => {
                                                                    return (
                                                                        <StyledTab
                                                                            label={(ev.distance == ""  || ev.distance == "-1" || race.type == "athletisme") ? ev.label.toUpperCase() : ev.distance}/>
                                                                    )
                                                                }) : null
                                                        }
                                                    </Tabs>
                                                </Box>
                                                {
                                                    race.events && race.events.length > 0 ?
                                                        race.events.sort((a, b) => a.label.localeCompare(b.label)).map((ev, index) => {
                                                            return (
                                                                <TabPanel value={tabValue} index={index} style={{
                                                                    backgroundColor: "#f6f6f8",
                                                                    border: "1px solid black",
                                                                    borderRadius: "5px"
                                                                }}>
                                                                    <div style={{
                                                                        fontWeight: "600",
                                                                        textTransform: "uppercase"
                                                                    }}>
                                                                        {
                                                                            race.type == "athletisme" && ev.distance != "" &&
                                                                            splitDistanceMobile(ev.distance, ev.label) &&
                                                                            splitDistanceMobile(ev.distance, ev.label).length > 0 ?
                                                                                splitDistanceMobile(ev.distance, ev.label).map(distance => {
                                                                                    return (
                                                                                        <div>
                                                                                            {splitDistanceMobile(ev.distance, ev.label).length > 1 ? "• " : ""}{distance}
                                                                                        </div>
                                                                                    )
                                                                                })

                                                                                : <div>{race.type == "athletisme" ? ev.distance : ev.label}</div>
                                                                        }
                                                                    </div>
                                                                    <Row style={{paddingTop: "10px"}}>
                                                                        <Col xs={1}>
                                                                            <BsClock size={"1.2em"}/>
                                                                        </Col>
                                                                        <Col xs={10} style={{
                                                                            fontSize: "15px",
                                                                            fontWeigh: "500"
                                                                        }}>
                                                                            {
                                                                                ev.beginningHour != "" ?
                                                                                    <p>Heure de départ
                                                                                        : {ev.beginningHour}</p> :
                                                                                    <p>Heure de départ non
                                                                                        communiquée.</p>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <hr style={{
                                                                        marginTop: "10px",
                                                                        marginBottom: "10px",
                                                                        marginLeft: "20px",
                                                                        marginRight: "20px"
                                                                    }}/>
                                                                    <Row>
                                                                        <Col xs={1}>
                                                                            <FaMountain size={"1.2em"}/>
                                                                        </Col>
                                                                        <Col xs={10} style={{
                                                                            fontSize: "15px",
                                                                            fontWeigh: "500"
                                                                        }}>
                                                                            {
                                                                                ev.deniv != "" && ev.deniv != "0" ?
                                                                                    <p>Dénivelé : {ev.deniv}m D+</p> :
                                                                                    <p>Dénivelé non communiqué.</p>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    <hr style={{
                                                                        marginTop: "10px",
                                                                        marginBottom: "10px",
                                                                        marginLeft: "20px",
                                                                        marginRight: "20px"
                                                                    }}/>
                                                                    <Row>
                                                                        <Col xs={1}>
                                                                            <IoMdPricetags size={"1.2em"}/>
                                                                        </Col>
                                                                        <Col xs={10} style={{
                                                                            fontSize: "15px",
                                                                            fontWeigh: "500"
                                                                        }}>
                                                                            {
                                                                                ev.price != "" ?
                                                                                    <p>Prix
                                                                                        : {ev.price.includes("€") ? ev.price : ev.price + "€"}</p>
                                                                                    : <p>Prix non communiqué.</p>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </TabPanel>
                                                            )
                                                        }) : null
                                                }
                                            </Box>

                                        </Col>
                                        <Col xs={5}>
                                            <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=" + (race.type == "athletisme" ? "athletisme" : "running") + "&page=1"}>
                                                <div style={{position: "relative", height: "198px", marginTop: "30px"}}>
                                                    <div style={{zIndex: "1", height: "100%"}}>
                                                        {
                                                            race && race.name ?
                                                                <div style={{
                                                                    left: 0,
                                                                    position: "absolute",
                                                                    textAlign: "center",
                                                                    top: "13%",
                                                                    width: "100%",
                                                                    color: "white", zIndex: "2", fontSize: "200%"
                                                                }}>
                                                                    <p style={{
                                                                        fontSize: "25px",
                                                                        color: "white",
                                                                        fontWeight: 700
                                                                    }}>
                                                                        BONS PLANS
                                                                    </p>
                                                                    <hr style={{
                                                                        backgroundColor: "white",
                                                                        fontWeight: 500,
                                                                        marginLeft: "40px",
                                                                        marginRight: "40px"
                                                                    }}/>
                                                                    <p style={{
                                                                        fontSize: "20px",
                                                                        color: "white",
                                                                        fontWeight: 500,
                                                                        marginLeft: "40px",
                                                                        marginRight: "40px"
                                                                    }}>
                                                                        Découvrez notre sélection
                                                                        de {race.type == "athletisme" ? "pointes" : "running"} pour
                                                                        la saison
                                                                    </p>
                                                                    <p style={{
                                                                        fontWeight: "600",
                                                                        borderRadius: "5px",
                                                                        marginTop: "15px",
                                                                        color: "black",
                                                                        border: "1px solid #333",
                                                                        backgroundColor: "white",
                                                                        fontSize: "13px",
                                                                        marginLeft: "150px",
                                                                        marginRight: "150px"
                                                                    }}>En profiter</p>

                                                                </div>
                                                                : null
                                                        }
                                                        <img
                                                            style={{
                                                                position: "relative",
                                                                width: "100%",
                                                                borderRadius: "5px",
                                                                height: "100%",
                                                                objectFit: "cover",
                                                                overflow: "hidden",
                                                                filter: "brightness(0.6)"
                                                            }}
                                                            onError={({currentTarget}) => {
                                                                currentTarget.onerror = null; // prevents looping
                                                                currentTarget.src = "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"
                                                            }}
                                                            src={
                                                                race && race.type == "trail" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/trail-running.jpeg" :
                                                                    race && race.type == "triathlon" ? "https://img.therunningcollective.fr/triathlonjeunes-5-jpeg" :
                                                                        race && race.type == "athletisme" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/sportcentrum-in-Oordegem-luchtfoto-Persregio-Dender.jpeg"
                                                                            : "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"}/>
                                                    </div>
                                                </div>
                                            </a>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            : <div style={{textAlign: 'center'}}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden"></span>
                                </Spinner>
                            </div>
                        : null}
                </BrowserView>

                { (isMobileOnly || isSmallScreen) && race ?
                    <div className="container-fluid" style={{paddingTop: "20px"}}>
                        <div style={{height: "200px"}}>
                            <div style={{height: "100%"}}>
                                <img
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        borderRadius: "5px",
                                        height: "100%",
                                        objectFit: "cover",
                                        overflow: "hidden",
                                        filter: "brightness(0.6)"
                                    }}
                                    onError={({currentTarget}) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"
                                    }}
                                    src={
                                        race && race.image && race.image != "" ? race.image :
                                            race && race.image && race.type == "trail" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/trail-running.jpeg" :
                                                race && race.image && race.type == "triathlon" ? "https://img.therunningcollective.fr/triathlonjeunes-5-jpeg" :
                                                    race && race.image && race.type == "athletisme" ? "https://blog.therunningcollective.fr/wp-content/uploads/2023/05/sportcentrum-in-Oordegem-luchtfoto-Persregio-Dender.jpeg"
                                                        : "https://blog.therunningcollective.fr/wp-content/uploads/2023/03/Sans-titre-2.001.jpeg"}/>
                            </div>
                        </div>

                        <div style={{paddingTop: "10px"}}>
                            <h1 style={{fontSize:"18px", fontWeight: "600", margin:"0", lineHeight: "22px"}}>
                                {race && race.name && race.name != "" ? race.name : null}
                            </h1>
                        </div>
                        <div>
                            <div style={{fontSize:"14px", fontWeight: "500", textTransform: "uppercase"}}>
                                {race && race.type && race.type != "" ? race.type : null}
                            </div>
                        </div>
                        <hr style={{marginBottom: "10px", marginTop: "10px"}}/>
                        <div>
                            <Row>
                                <Col xs={1}>
                                    <BsPinMap size={"2em"}/>
                                </Col>
                                <Col xs={10} style={{
                                    marginLeft: "10px",
                                    fontSize: "13px",
                                    fontWeigh: "500"
                                }}>
                                    {race.town} {race.country ? "(" + race.country + ")" : null}
                                </Col>
                            </Row>
                            <Row style={{paddingTop: "10px"}}>
                                <Col xs={1}>
                                    <BsCalendarMonth size={"2em"}/>
                                </Col>
                                <Col xs={10} style={{
                                    marginLeft: "10px",
                                    fontSize: "13px",
                                    fontWeigh: "500"
                                }}>
                                    {date}
                                </Col>
                            </Row>
                            <Row style={{paddingTop: "10px"}}>
                                <Col xs={1}>
                                    <FaRunning size={"2em"}/>
                                </Col>
                                <Col xs={10} style={{
                                    marginLeft: "10px",
                                    fontSize: "13px",
                                    fontWeigh: "500"
                                }}>
                                    {
                                        events.map((event, index) => {
                                            if(event != "-1" && event != ""){
                                                if (index == (events.length-1)){
                                                    return(
                                                        event
                                                    )
                                                } else {
                                                    return(
                                                        event + ", "
                                                    )
                                                }

                                            }
                                        })}
                                </Col>
                            </Row>
                            {
                                race.beginningHour != "" ?
                                    <Row style={{paddingTop: "10px"}}>
                                        <Col xs={1}>
                                            <BsClock size={"2em"}/>
                                        </Col>
                                        <Col xs={10} style={{
                                            marginLeft: "10px",
                                            fontSize: "13px",
                                            fontWeigh: "500"
                                        }}>
                                            A partir de {race.beginningHour}
                                        </Col>
                                    </Row>
                                    : null
                            }
                            <div style={{paddingTop: "10px"}}>
                                {race.starRate == "1" ?
                                    <div>
                                        <BsStarFill size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;
                                        <BsStar size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;
                                        <BsStar size={"2em"}/>
                                    </div> : race.starRate == "2" ?
                                        <div>
                                            <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                            size={"2em"}/>&nbsp;<BsStar size={"2em"}/>&nbsp;<BsStar
                                            size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                        </div>
                                        : race.starRate == "3" ?
                                            <div>
                                                <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                size={"2em"}/>&nbsp;<BsStarFill size={"2em"}/>&nbsp;
                                                <BsStar size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                            </div> : race.starRate == "4" ?
                                                <div>
                                                    <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                    size={"2em"}/>&nbsp;<BsStarFill
                                                    size={"2em"}/>&nbsp;<BsStarFill
                                                    size={"2em"}/>&nbsp;<BsStar size={"2em"}/>
                                                </div> : race.starRate == "5" ?
                                                    <div>
                                                        <BsStarFill size={"2em"}/>&nbsp;<BsStarFill
                                                        size={"2em"}/>&nbsp;<BsStarFill
                                                        size={"2em"}/>&nbsp;<BsStarFill
                                                        size={"2em"}/>&nbsp;<BsStarFill
                                                        size={"2em"}/>
                                                    </div> : null
                                }
                            </div>
                            {race.lowPrice && race.lowPrice != "0" && race.lowPrice != "0€" ?
                                <Row style={{paddingTop: "10px"}}>
                                    <Col xs={1}>
                                        <IoMdPricetags size={"2em"}/>
                                    </Col>
                                    <Col xs={10} style={{
                                        marginLeft: "10px",
                                        fontSize: "13px",
                                        fontWeigh: "500"
                                    }}>
                                        A partir
                                        de {race.lowPrice.includes("€") ? race.lowPrice : race.lowPrice + "€"}
                                    </Col>
                                </Row>
                                :
                                <Row style={{paddingTop: "10px"}}>
                                    <Col xs={1}>
                                        <IoMdPricetags size={"2em"}/>
                                    </Col>
                                    <Col xs={10} style={{
                                        marginLeft: "10px",
                                        fontSize: "13px",
                                        fontWeigh: "500"
                                    }}>
                                        Prix non communiqué
                                    </Col>
                                </Row>}
                            {race.raceLink != "" ?
                                <Row style={{paddingTop: "10px"}}>
                                    <Col xs={1}>
                                        <CgWebsite size={"2em"}/>
                                    </Col>
                                    <Col xs={10} style={{
                                        marginLeft: "10px",
                                        fontSize: "13px",
                                        fontWeigh: "500"
                                    }}>
                                        <a href={race.raceLink} target="_blank"
                                           style={{fontSize: "13px", fontWeigh: "500"}}>Voir le site
                                            de la course</a>
                                    </Col>
                                </Row>
                                : null
                            }
                        </div>
                        <hr style={{marginBottom: "10px", marginTop: "10px"}}/>
                        <div>
                            {
                                race.registrationLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) ?
                                    <a href={race.registrationLink} target="_blank">
                                        <div style={{
                                            border: "3px solid black",
                                            backgroundColor: "#4fa0a6",
                                            borderRadius: "10px",
                                            height: "45px",
                                            textAlign: "center",
                                            color: "white",
                                            top: "15px",
                                            marginBottom: race.liveLink != "" ? "10px" : "0px"
                                        }}>
                                            <p style={{
                                                paddingTop: "10px",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                                color: "white",
                                            }}>LIEN DE L'INSCRIPTION</p></div>
                                    </a>

                                    : null
                            }
                            {
                                race.liveLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))?
                                    <a href={race.liveLink} target="_blank">
                                        <div style={{
                                            border: "1px solid black",
                                            backgroundColor: "orange",
                                            borderRadius: "10px",
                                            height: "45px",
                                            textAlign: "center",
                                            color: "white",
                                            top: "15px",
                                            textTransform: "uppercase",
                                            marginBottom: race.racePicturesLink != "" ? "10px" : "0px"
                                        }}>
                                            <p style={{
                                                paddingTop: "10px",
                                                fontWeight: "600",
                                                fontSize: "15px"
                                            }}>Lien des résultats</p></div>
                                    </a>

                                    : null
                            }
                            {
                                race.racePicturesLink != "" && (new Date(race.beginDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))?
                                    <a href={race.racePicturesLink} target="_blank">
                                        <div style={{
                                            border: "1px solid black",
                                            backgroundColor: "red",
                                            borderRadius: "10px",
                                            height: "45px",
                                            textAlign: "center",
                                            color: "white",
                                            top: "15px",
                                            textTransform: "uppercase"
                                        }}>
                                            <p style={{
                                                paddingTop: "10px",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                                color: "white",
                                            }}>Lien des photos</p></div>
                                    </a>

                                    : null
                            }
                        </div>
                        <hr style={{marginBottom: "10px", marginTop: "10px"}}/>
                        {/* related product slider */}
                        <RelatedProductRaceSlider
                            headCategory={race.type == "athletisme" ? "/products/spikes" : "/products/shoes"}
                            category={
                                race.type == "triathlon" || race.type == "running" ? "Compétitions" :
                                    race.type == "athletisme" ? "Demi-fond" : race.type == "trail" ?
                                        !race.name.toLowerCase().includes("ultra") && !race.description.toLowerCase().includes("ultra") ? "Trail court" : "Trail long" : "Compétitions"
                            }
                            type={race.type == "triathlon" ? "running" : race.type}
                            product={{}}
                            origin={"fr"}
                        />
                        <hr style={{marginBottom: "10px", marginTop: "10px"}}/>
                        <div className="container-fluid">
                            { race.events && race.events.length > 0 ?
                                <Row>
                                    {
                                        race.events.sort((a, b) => a.label.localeCompare(b.label)).map((event, index) => {
                                            return(
                                                    <Col xs={5} style={{
                                                        marginBottom: index < race.events.length - 2 ? "20px" : "0px",
                                                        backgroundColor: "rgb(235, 235, 235)", border: "1px solid black", borderRadius: "20px", marginLeft: "20px"}}>
                                                        <a  href={race.registrationLink} target="_blank">
                                                        <div style={{
                                                            paddingTop: "10px",
                                                            fontSize: "12px",
                                                            lineHeight: "20px",
                                                            fontWeight: "600",
                                                            textAlign: "center"}}>
                                                            {event.label}
                                                        </div>
                                                            {
                                                            race.type == "athletisme" && event.distance != "" &&
                                                                splitDistanceMobile(event.distance, event.label) &&
                                                                splitDistanceMobile(event.distance, event.label).length > 0 ?
                                                                splitDistanceMobile(event.distance, event.label).map(distance => {
                                                                    return (
                                                                        <div style={{
                                                                            paddingTop: "5px",
                                                                            paddingBottom: "5px",
                                                                            fontSize: "10px",
                                                                            lineHeight: "20px",
                                                                            fontWeight: "600",
                                                                            textAlign: "center"

                                                                        }}>
                                                                            <p style={{
                                                                                backgroundColor: "black",
                                                                                color: "white",
                                                                                borderRadius: "20px",
                                                                                fontWeight: "500",
                                                                                fontSize: "12px",
                                                                                lineHeight: "18px",
                                                                                padding: "5px"
                                                                            }}>{distance}</p>
                                                                        </div>
                                                                    )
                                                                })

                                                                : <div style={{
                                                                    paddingTop: "10px",
                                                                    paddingBottom: "10px",
                                                                    fontSize: "10px",
                                                                    lineHeight: "20px",
                                                                    fontWeight: "600",
                                                                    textAlign: "center"

                                                                }}>
                                                                    <p style={{
                                                                        backgroundColor: "black",
                                                                        color: "white",
                                                                        borderRadius: "20px",
                                                                        fontWeight: "500",
                                                                        fontSize: "12px",
                                                                    }}>{event.distance}</p>
                                                                </div>
                                                        }

                                                        {
                                                            event.beginningHour != "" ?
                                                                <div style={{paddingBottom: "10px", marginLeft: "10px",
                                                                    fontSize: "10px",
                                                                    fontWeight: "500"}}>
                                                                    <BsClock size={"1em"}/>&nbsp;&nbsp; A partir de {race.beginningHour}
                                                                </div> :
                                                                <p style={{fontSize:"10px", fontWeight:"500",
                                                                    textAlign: "center",
                                                                    lineHeight: "20px"}}>Heure de départ non
                                                                    communiquée.</p>
                                                        }
                                                        <div>

                                                        </div>
                                                </a>
                                        </Col>
                                            )
                                        })
                                    }

                                </Row>
                                : null }
                        </div>
                        <hr style={{marginBottom: "10px", marginTop: "10px"}}/>
                        {race && race.description && race.description != "" ?
                            <div style={{
                                border: "1px solid black",
                                borderRadius: "10px",
                                padding: "10px",
                                marginBottom: "20px",
                                overflow: "hidden"
                            }}>
                                <b>L'ÉVÈNEMENT EN QUELQUES MOTS :</b>
                                <h2  style={{fontSize:"14px", lineHeight:"22px"}} className="race-mobile-description">
                                    {parse(race.description)}
                                </h2>
                            </div> : <div style={{
                                border: "1px solid black",
                                borderRadius: "10px",
                                padding: "10px",
                                marginBottom: "20px",
                                overflow: "hidden"
                            }}>
                                <b>L'ÉVÈNEMENT EN QUELQUES MOTS :</b>
                                <div>
                                    {race.type == "running" ?
                                        <h2  style={{fontSize:"14px", lineHeight:"22px"}}>
                                            Préparez-vous à vivre l'excitation pure de la
                                            compétition sur route ! Notre course vous offre une
                                            expérience inoubliable, alliant vitesse, endurance
                                            et détermination. Parcourez les rues animées de la
                                            ville, vibrez au rythme de l'énergie collective des
                                            coureurs et de la foule en liesse.
                                            Que vous soyez un athlète aguerri ou un amateur
                                            passionné, cette course est conçue pour tous les
                                            niveaux. En franchissant la ligne de départ, vous
                                            vous lancerez dans un voyage où chaque foulée vous
                                            rapproche de l'accomplissement personnel. Ressentez
                                            l'adrénaline monter en vous tandis que vous dépassez
                                            vos limites, repoussez vos propres records et
                                            inspirez les autres avec votre détermination. Soyez
                                            prêt à ressentir l'euphorie de franchir la ligne
                                            d'arrivée, porté par les acclamations et la fierté
                                            d'avoir relevé le défi. Êtes-vous prêt à vivre une
                                            expérience de course sur route inoubliable ?
                                        </h2> : race.type == "trail" ?

                                            <h2  style={{fontSize:"14px", lineHeight:"22px"}}>Êtes-vous prêt à relever le défi ultime de la
                                                nature sauvage ? Notre trail vous invite à
                                                explorer les sentiers les plus exigeants et
                                                pittoresques de la région.

                                                Plongez au cœur d'une aventure épique, où chaque
                                                pas vous rapproche de la beauté naturelle et de
                                                l'adrénaline pure. Traversez des paysages à
                                                couper le souffle, entre montagnes majestueuses,
                                                forêts verdoyantes et rivières tumultueuses.

                                                Êtes-vous prêt à repousser vos limites
                                                ?</h2> : race.type == "triathlon" ?

                                                <h2  style={{fontSize:"14px", lineHeight:"22px"}}>
                                                    Préparez-vous à plonger dans une aventure
                                                    sportive complète
                                                    avec {race.name.toUpperCase()} !<br/><br/>

                                                    Ce défi ultime combine natation, cyclisme et
                                                    course à pied pour tester vos compétences
                                                    athlétiques et votre endurance.<br/>
                                                    Plongez dans les eaux claires et
                                                    cristallines, faites des vagues en vous
                                                    déplaçant avec grâce et puissance dans la
                                                    première étape de la natation.<br/>
                                                    Ensuite, enfourchez votre vélo et parcourez
                                                    des paysages pittoresques et variés, en
                                                    pédalant avec détermination et en repoussant
                                                    vos limites.<br/><br/>

                                                    Enfin, chaussez vos chaussures de course et
                                                    dévalez les routes et sentiers, en puisant
                                                    dans vos réserves d'énergie pour franchir la
                                                    ligne d'arrivée avec panache.<br/>
                                                    Notre triathlon offre une expérience
                                                    incroyable, où vous vous mesurerez à
                                                    vous-même et aux autres athlètes, dans une
                                                    compétition amicale et stimulante.<br/><br/>

                                                    Vous serez inspiré par l'esprit de
                                                    camaraderie et la détermination des
                                                    participants qui repoussent leurs propres
                                                    limites pour atteindre
                                                    l'excellence.<br/><br/>
                                                    Êtes-vous prêt à plonger dans ce défi
                                                    triathlonien et à devenir un véritable
                                                    champion ?<br/>
                                                </h2> : null

                                    }
                                </div>
                            </div>}

                    </div>
                    : loading ?

                        <div style={{textAlign: 'center'}}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        </div>
                 : null}

            </LayoutOne>
        </Fragment>
    );
};

Race.propTypes = {
    location: PropTypes.object
};

export default Race;

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const MyTabScrollButton = forwardRef((props, ref) => {
    const {direction, ...other} = props;

    return (
        <ButtonBase
            component="div"
            ref={ref}
            style={{opacity: other.disabled ? 0 : 1, paddingBottom: "15px"}}
            {...other}
        >
            {direction === "left" ? (
                <ArrowBackIcon fontSize="small"/>
            ) : (
                <ArrowForwardIcon fontSize="small"/>
            )}
        </ButtonBase>
    );
});

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}